module.exports = __webpack_public_path__ + "assets/img/mstile-266x266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mstile-266x266.png
// module id = 1965
// module chunks = 0